//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { LocalizationHelper } from '../../../helpers'
import { EventsNames } from '../../../helpers/events-names'
import { CommonHelper } from '../../../helpers/common-helper'
import { PopupType } from '../../../helpers/popup-manager'

import { AlarmGroupService } from '../../../services/alarm-group/alarm-group.service'

import { CreateEditScope, CreateEditController } from '../../common/common.create-edit.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'

import { Enums } from '../../../models/common/enums'
import { IOpObject } from '../../../models/util/interfaces'

import { OpAlarmGroup } from '../../../models/core';
import { IDeferred } from 'angular';

interface AlarmGroupCreateEditScope extends CreateEditScope {

}

export class AlarmGroupCreateEditController extends CreateEditController {

    //#region Consts

    public get ALARM_GROUP_OPEN_CREATE_EDIT_POPUP() { return 'ALARM_GROUP_OPEN_CREATE_EDIT_POPUP' }
    public get ALARM_GROUP_OPEN_BULK_EDIT_POPUP() { return 'ALARM_GROUP_OPEN_BULK_EDIT_POPUP' }
    
    //#endregion

    //#region Ctor

    public constructor(
        private $scope: AlarmGroupCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private alarmGroupService: AlarmGroupService,
        protected referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenceType)

        this.setEvents()
        this.setOptions()
    }

    //#endregion 

    //#region Events

    public onInit(args: any[]): void {
        if ((args != null) && (args[0] != null)) {
            const createEditInitParams: CreateEditInitParams = args[0]

            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)
            this.$scope.popupType = PopupType.CREATE_EDIT_POPUP

            if (createEditInitParams.referenceObject != null && createEditInitParams.referenceObject.idObject > 0) {
                createEditInitParams.referenceObject.dataList = this.alarmGroupService.createDataListFromAlarmGroup(createEditInitParams.referenceObject)
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    public onInitBulk(args: any[]): void {
        if ((args != null) && (args[0] != null)) {
            const bulkEditInitParams: BulkEditInitParams = args[0]
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)

            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)
            this.$scope.popupType = PopupType.BULK_EDIT_POPUP

            this.$scope.gridData = args[0]

            if (args[1] != null) {
                this.$scope.gridColumns = args[1]
            }

            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    public onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const alarmGroupToSave: OpAlarmGroup = OpAlarmGroup.fromIOpObject(objectToSave)
        const deferred: IDeferred<IOpObject> = this.$q.defer<IOpObject>()

        this.alarmGroupService.saveAlarmGroup(alarmGroupToSave)
            .then((savedObject: OpAlarmGroup) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                deferred.reject(error);
            })

        return deferred.promise
    }

    public onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const alarmGroupToSave: OpAlarmGroup = OpAlarmGroup.fromIOpObject(objectToSave)
        const deferred: IDeferred<IOpObject> = this.$q.defer<IOpObject>()

        this.alarmGroupService
            .saveAlarmGroup(alarmGroupToSave, true)
            .then((savedObject: OpAlarmGroup) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                deferred.reject(error)
            })

        return deferred.promise
    }

    //#endregion

    //#region Setup

    public setEvents(): void {
        this.$scope.$on(this.ALARM_GROUP_OPEN_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => { this.onInit(args) })
        this.$scope.$on(this.ALARM_GROUP_OPEN_BULK_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => { this.onInitBulk(args) })
    }

    public setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.isCreateEditAdditionalFields = true

        this.$scope.options = {
            title: "",
            type: PopupType.ALARM_GROUP_POPUP,//NIE UŻYWAĆ!!!
            referenceType: this.referenceType,
            onSave: (objectToSave: IOpObject) => { return this.onSave(objectToSave) },
            onBulkSave: (objectToSave: IOpObject) => { return this.onBulkSave(objectToSave) },
            onClose: null,
            onSubmit: null,
            submitBulkEdit: null,
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.alarmGroupSaved,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
        }
    }

    //#endregion
}